import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { AppConfigService } from './app-config.service';
import { InsightsUtility } from '../utilities/insights/insights.utility';
import { GeneralError } from '../insights/errors/general.error';

/**
 * @deprecated use RecoveryManager instead.
 */
@Injectable()
export class ErrorHandlerService {

	constructor(private http: HttpClient, private appConfigService: AppConfigService, private insightsUtility: InsightsUtility) {
	}

	public handleError<T>(operation = 'operation', result?: T) {
		return (error: any): Observable<T> => {

			this.log(operation, error)
				.subscribe(() => {
					// subscribe to cause log call but not using the return value
				});

			return of(result as T);
		};
	}

	private log(operation: string, error: any): Observable<any> {
		this.insightsUtility.event(new GeneralError({
			message: `${ operation } failed: ${ error.message }`,
			internalError: error
		}));

		return of(null);
	}
}
